import { render, staticRenderFns } from "./BannerDetails.vue?vue&type=template&id=539b5578&"
import script from "./BannerDetails.vue?vue&type=script&lang=js&"
export * from "./BannerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports